import {
    collection,
    addDoc,
    getDoc,
    getDocs,
    updateDoc,
    deleteDoc,
    doc,
    query,
    where,
    orderBy,
    limit,
    serverTimestamp
} from 'firebase/firestore';
import { db } from '../../firebase/firebaseConfig';
import { COLLECTIONS } from '../../constants/collections';

/**
 * Generic Firestore service for CRUD operations
 */

// Create document
export const createDocument = async (collectionName, data) => {
    const docRef = await addDoc(collection(db, collectionName), {
        ...data,
        createdAt: serverTimestamp(),
        updatedAt: serverTimestamp()
    });
    return docRef.id;
};

// Get document by ID
export const getDocument = async (collectionName, documentId) => {
    const docRef = doc(db, collectionName, documentId);
    const docSnap = await getDoc(docRef);

    if (docSnap.exists()) {
        return { id: docSnap.id, ...docSnap.data() };
    }
    return null;
};

// Get all documents from collection
export const getAllDocuments = async (collectionName, conditions = []) => {
    let q = collection(db, collectionName);

    if (conditions.length > 0) {
        const constraints = conditions.map(cond => {
            if (cond.type === 'where') {
                return where(cond.field, cond.operator, cond.value);
            } else if (cond.type === 'orderBy') {
                return orderBy(cond.field, cond.direction || 'asc');
            } else if (cond.type === 'limit') {
                return limit(cond.value);
            }
            return null;
        }).filter(Boolean);

        q = query(q, ...constraints);
    }

    const querySnapshot = await getDocs(q);
    return querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
};

// Update document
export const updateDocument = async (collectionName, documentId, data) => {
    const docRef = doc(db, collectionName, documentId);
    await updateDoc(docRef, {
        ...data,
        updatedAt: serverTimestamp()
    });
};

// Delete document
export const deleteDocument = async (collectionName, documentId) => {
    const docRef = doc(db, collectionName, documentId);
    await deleteDoc(docRef);
};

// Query documents with conditions
export const queryDocuments = async (collectionName, conditions) => {
    return getAllDocuments(collectionName, conditions);
};

export default {
    createDocument,
    getDocument,
    getAllDocuments,
    updateDocument,
    deleteDocument,
    queryDocuments
};
